// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('../internals/is-regexp');
var requireObjectCoercible = require('../internals/require-object-coercible');

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(requireObjectCoercible(that));
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/validate-string-method-arguments.js
// module id = 238
// module chunks = 0